export default "__VITE_ASSET__CsY$HixB__"